import { vec3 } from 'gl-matrix';
export default function getVoxelThicknessAlongNormal(volume, normal) {
    const { direction, spacing } = volume;
    const iVector = direction.slice(0, 3);
    const jVector = direction.slice(3, 6);
    const kVector = direction.slice(6, 9);
    return (Math.abs(vec3.dot(iVector, normal)) * spacing[0] +
        Math.abs(vec3.dot(jVector, normal)) * spacing[1] +
        Math.abs(vec3.dot(kVector, normal)) * spacing[2]);
}
